import {LocationDao} from '../../dao';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';
const FUNCTION_CODE = 'CREATE_CUSTOMER_CATEGORY';

export async function createLocation(
    userData: Record<string, string>,
    location: Record<string, any>
) {
    try {
        const result = await LocationDao.createLocation(userData.userToken, location);

        return result;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
